import React from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableViewIcon from '@mui/icons-material/TableView';

/** Microsoft Excel green */
const EXCEL_COLOR = '#217346';
/** Standard PDF / Adobe red */
const PDF_COLOR = '#D32F2F';

const exportIconButtonSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  p: 1,
};

const exportIconSx = { fontSize: 28 };

export function ExcelExportIconButton({ disabled = false, onClick, title = 'Export Excel' }) {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          aria-label={title}
          disabled={disabled}
          onClick={onClick}
          sx={{
            ...exportIconButtonSx,
            color: EXCEL_COLOR,
            '&:hover': { bgcolor: 'rgba(33, 115, 70, 0.1)' },
            '&.Mui-disabled': { color: 'action.disabled' },
          }}
        >
          <TableViewIcon sx={exportIconSx} />
        </IconButton>
      </span>
    </Tooltip>
  );
}

export function PdfExportIconButton({
  disabled = false,
  loading = false,
  onClick,
  title = 'Export PDF',
}) {
  const tooltip = loading ? 'Exporting…' : title;
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          aria-label={title}
          disabled={disabled}
          onClick={onClick}
          sx={{
            ...exportIconButtonSx,
            color: PDF_COLOR,
            '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.1)' },
            '&.Mui-disabled': { color: 'action.disabled' },
          }}
        >
          {loading ? (
            <CircularProgress size={26} sx={{ color: PDF_COLOR }} />
          ) : (
            <PictureAsPdfIcon sx={exportIconSx} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}
